import { Box, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";
import { List, ListItem, ListItemText, TextField, Button, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import CamKetKhachHang from "./CamKetKhachHang";
import { Link as RouterLink } from 'react-router-dom';
import anhDaiDien from '../../src/assets/image/anh-dai-dien.jpg';
import { useState } from "react";
import YeuCauBaoGiaModal from "../modal/YeuCauBaoGiaModal";
import DangKyLaiThuModal from "../modal/DangKyLaiThuModal";
import DatLichbaoDuongModal from "../modal/DatLichbaoDuongModal";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(8),
    },
    vehicleTab: {
        marginBottom: theme.spacing(4), // Thêm khoảng cách bên dưới tab xe
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    listTitle: {
        backgroundColor: '#023f80',
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(2),
        fontWeight: 600,
    },
    listItem: {
        '&:hover': {
            backgroundColor: '#023f80',
        },
        color: theme.palette.primary.contrastText,
        borderBottom: '1px solid #1673d6',

    },
    formTitle: {
        backgroundColor: '#023f80',
        color: theme.palette.secondary.contrastText,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontWeight: 600,
    },
    formControl: {
        marginBottom: theme.spacing(2),
        width: '100%',
        padding: '0 5px'
    },
    button: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
        marginBottom: theme.spacing(1),
    },
    datePicker: {
        display: 'flex',
        alignItems: 'center',
    },
    dateInput: {
        flexGrow: 1,
        marginRight: theme.spacing(1),
    },
    boxList: {
        backgroundColor: '#0351A4',
        marginBottom: '5px',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden'
    },
    listDanhMuc: {
        paddingBottom: '0px !important'
    },
    smallSelect: {
        '& .MuiSelect-select': {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            fontSize: theme.typography.body2.fontSize,
            minHeight: 'auto', // Loại bỏ minHeight mặc định có thể gây lệch
        },
    },
    labelRoot: {
        top: 'auto', // Reset top để chúng ta có thể kiểm soát
        bottom: '50%',
        left: '17px',
        transform: 'translateY(50%)', // Căn giữa theo chiều dọc
        '&.MuiInputLabel-shrink': {
            transform: 'translate(0px, -6px) scale(0.75)',
        },
    },
    boxYeucau: {
        border: '1px solid #0351A4',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        marginTop: '20px'
    },

    boxYeucauButton: {
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(1),
    },
    boxYeucauNoidung: {
        margin: theme.spacing(1),
        textAlign: 'center'
    },
    boxYeucauAnh: {
        margin: theme.spacing(1),
    },
    titleYeuCau: {
        fontSize: '14px',
        fontWeight: 600
    },
    titleYeuCau2: {
        fontSize: '14px',
    },
    link: {
        textDecoration: 'none !important',
        fontSize: '16px !important',
        color: '#2a6496 !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: '#000 !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    }
}));

const DanhMucVaBaoGia = () => {
    const classes = useStyles();

    const [isModalOpenYeuCauBaoGia, setIsModalOpenYeuCauBaoGia] = useState(false);
    const handleOpenModalYeuCauBaoGia = () => {
        setIsModalOpenYeuCauBaoGia(true);
    };
    const handleCloseModalYeuCauBaoGia = () => {
        setIsModalOpenYeuCauBaoGia(false);
    };

    const [isModalOpenDangKyLaiThu, setIsModalOpenDangKyLaiThu] = useState(false);
    const handleOpenModalDangKyLaiThu = () => {
        setIsModalOpenDangKyLaiThu(true);
    };
    const handleCloseModalDangKyLaiThu = () => {
        setIsModalOpenDangKyLaiThu(false);
    };

    const [isModalOpenBaoDuong, setIsModalOpenBaoDuong] = useState(false);
    const handleOpenModalBaoDuong = () => {
        setIsModalOpenBaoDuong(true);
    };
    const handleCloseModalBaoDuong = () => {
        setIsModalOpenBaoDuong(false);
    };

    return (
        <Box>
            <Box className={classes.boxList}>
                <Typography className={classes.listTitle}>
                    DANH MỤC SẢN PHẨM
                </Typography>
                <List className={classes.listDanhMuc}>
                    <ListItem component={RouterLink} to="/danh-sach/territory" button className={classes.listItem}>
                        <ListItemText primary="Ford Territory" />
                    </ListItem>
                    <ListItem component={RouterLink} to="/danh-sach/everest" button className={classes.listItem}>
                        <ListItemText primary="Ford Everest" />
                    </ListItem>
                    <ListItem component={RouterLink} to="/danh-sach/explorer" button className={classes.listItem}>
                        <ListItemText primary="Ford Explorer" />
                    </ListItem>
                    <ListItem component={RouterLink} to="/danh-sach/ranger" button className={classes.listItem}>
                        <ListItemText primary="Ford Ranger" />
                    </ListItem>
                    <ListItem component={RouterLink} to="/danh-sach/transit" button className={classes.listItem}>
                        <ListItemText primary="Ford Transit" />
                    </ListItem>
                </List>
            </Box>

            <Box className={classes.boxYeucau}>
                <Box className={classes.boxYeucauAnh}>
                    <img
                        src={anhDaiDien}
                        alt="Hoàng Minh Quân"
                        className={classes.image}
                    />
                </Box>
                <Box className={classes.boxYeucauNoidung}>
                    <Typography className={classes.titleYeuCau}>
                        Phụ trách kinh doanh Ford Thái Nguyên
                    </Typography>
                    <Typography className={classes.titleYeuCau}>
                        Hoàng Minh Quân
                    </Typography>
                    <Typography className={classes.titleYeuCau}>
                        Hotline: <RouterLink className={classes.link}>0966.122.815</RouterLink>
                    </Typography>
                    <Typography className={classes.titleYeuCau}>
                        Email: <RouterLink className={classes.link}>minhquanhh99@gmail.com</RouterLink>
                    </Typography>
                    <Typography className={classes.titleYeuCau2}>
                        - Giá Xe, Khuyến Mại, Trả Góp, Dịch Vụ Tốt Nhất
                    </Typography>
                </Box>
                <Box className={classes.boxYeucauButton}>
                    <Button variant="outlined" className={classes.button} fullWidth onClick={handleOpenModalYeuCauBaoGia}>
                        Yêu cầu báo giá
                    </Button>
                    <Button variant="outlined" className={classes.button} fullWidth onClick={handleOpenModalDangKyLaiThu}>
                        Đăng ký lái thử
                    </Button>
                    <Button variant="outlined" className={classes.button} fullWidth onClick={handleOpenModalBaoDuong}>
                        Đặt lịch bảo dưỡng
                    </Button>
                </Box>
            </Box>
            <CamKetKhachHang />
            <YeuCauBaoGiaModal
                open={isModalOpenYeuCauBaoGia}
                onClose={handleCloseModalYeuCauBaoGia}
            />

            <DangKyLaiThuModal
                open={isModalOpenDangKyLaiThu}
                onClose={handleCloseModalDangKyLaiThu}
            />

            <DatLichbaoDuongModal
                open={isModalOpenBaoDuong}
                onClose={handleCloseModalBaoDuong}
            />
        </Box>
    );
};

export default function ContentLeft() {
    return (
        <DanhMucVaBaoGia />

    );
}